import { observer } from 'mobx-react-lite'
import { useDocStore } from 'stores/DocStore'
import { Item } from './Item'
import { Section } from '../Section/Section'
import { EmptyState } from '../Section/EmptyState'
import EmptyStateStyles from '../Section/Section.module.scss'
import cx from 'classnames'
import { TrackChanges } from './TrackChanges'
import { Fragment } from 'react'
import { useCanViewAs } from 'components/Can'
import { UserRole } from 'types'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

export const List = observer(({ workspaceId }: { workspaceId: number }) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const canViewAs = useCanViewAs(workspaceId)
  const docStore = useDocStore()
  const filteredSections = docStore.rightRailStore.sections.filter((section) => {
    if (section.key === 'trackedChanges') {
      if (isSystemRedesignEnabled) return false

      return canViewAs([UserRole.GUEST, UserRole.MEMBER, UserRole.ADMIN, UserRole.SUPER_ADMIN])
    }

    return true
  })

  return (
    <>
      {filteredSections.map((section) => {
        const items = section.items(section.type)
        const AllFilterWithItems = docStore.filters.activeBaseKeys.length === 0 && items.length > 0
        const sectionFilterIsActive = docStore.filters.activeKeys.has(section.key)

        return (
          <Fragment key={section.key}>
            {(section.showOverride() || AllFilterWithItems || sectionFilterIsActive) && (
              <Section label={section.label} sectionKey={section.key}>
                {section.key === 'trackedChanges' && <TrackChanges />}
                <EmptyState
                  sectionKey={section.key}
                  sectionName={section.label}
                  className={cx({ [EmptyStateStyles.trackedChanges]: section.key === 'trackedChanges' })}
                />
                {items.map((collabItem) => {
                  const item = collabItem.item
                  const id = 'id' in item ? item.id.toString() : item.uuid
                  return <Item key={`${collabItem.type}-${id}`} {...collabItem} />
                })}
              </Section>
            )}
          </Fragment>
        )
      })}
    </>
  )
})
